import { List } from '@mui/material';
import { MouseEvent, ReactNode } from 'react';
import { panelListSx, railListSx } from './styles';

interface Props {
    children: ReactNode;
    dense: boolean;
    /**
     * `rail` é a lista do acordeão, presa ao trilho vertical que a agrupa
     * dentro da coluna; `panel` é a do painel flutuante, onde o próprio painel
     * já agrupa e cabe um item mais espaçado.
     */
    variant?: 'rail' | 'panel';
    /** Chamado quando o clique foi num link — não quando foi num grupo. */
    onNavigate?: () => void;
}

/** A lista de filhos de um grupo, nas duas formas. */
const NestedList = ({ children, dense, variant = 'rail', onNavigate }: Props) => {
    const handleClick = (event: MouseEvent<HTMLElement>) => {
        // Clicar no cabeçalho de um grupo aninhado só expande o acordeão; quem
        // fecha o painel é a navegação, e só ela renderiza um <a>.
        if (onNavigate && (event.target as HTMLElement).closest('a')) {
            onNavigate();
        }
    };

    return (
        <List
            dense={dense}
            component="div"
            disablePadding
            onClick={handleClick}
            sx={variant === 'panel' ? panelListSx : railListSx}
        >
            {children}
        </List>
    );
};

export default NestedList;
